<template>
  <section class="c-section-share block m-t p-b">
    <div class="container">
      <div class="row">
        <div class="col text-center font-default">
          <h3 class="fnt font-deco c-section-share__title">
            {{ this.user.firstname }},
          </h3>
          <p v-html="$t('SHARE_PAGE__INTRO_2')"></p>
        </div>
      </div>
      <div class="block p-t-b">
        <div class="text-center">
          <el-button type="primary" @click="share" class="fnt">{{
            $t("STATUS__SHARE")
          }}</el-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SectionShare",
  props: {
    user: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    share() {
      this.$router.push({
        name: "share",
        query: { t: this.user.token, u: this.user.id }
      })
    }
  }
}
</script>

<style scoped></style>
